import React from 'react'
import { Box } from '@mui/material'

import { WrestlerItem } from './wrestler'
import { AvatarStack } from '../../namebar'

export function AppearanceItem(props) {
  const {
    children = null,
    winner,
    manager,
    loser,
    wrestler
  } = props
  
    // winner && !manager && (<Chip color="success"
    //   label="Winner"
    //   icon={<WinnerIcon />} />)
  
  if (manager) {
    return (
      <Box>
        <AvatarStack collection={[wrestler]} />
        <Box>{children}</Box>
      </Box>
    )
  }
  
  return (
    <Box sx={{
      backgroundColor: winner ? '#00800080' : loser ? '#ff000080' : 'transparent',
      padding: .5
    }}>
      <WrestlerItem {...wrestler} />
      <Box>{children}</Box>
    </Box>
  )
}
